// extracted by mini-css-extract-plugin
export default {"dropdownItem":"dropdownItem__JwS2c","label":"label__h9ftF","input":"input__K0tmy","form":"form__tgkst","table":"table__mzXof","numberInput":"numberInput__uCO_O"};